var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base } from '@or-sdk/base';
import { SERVICE_KEY } from './constants';
export class Payments extends Base {
    constructor(params) {
        const { token, paymentsUrl, discoveryUrl } = params;
        super({
            token,
            serviceUrl: paymentsUrl,
            serviceKey: SERVICE_KEY,
            discoveryUrl,
        });
    }
    getCustomerData() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/customers/current',
            });
            return data;
        });
    }
    getMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/methods',
            });
            return data;
        });
    }
    getSetupMethodSecret() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'PUT',
                route: '/payment/setup',
            });
            return data;
        });
    }
    deleteMethod(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'DELETE',
                route: '/payment/card',
                data: {
                    id,
                },
            });
        });
    }
    setDefaultMethod(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'POST',
                route: '/payment/card',
                data: {
                    id,
                },
            });
        });
    }
    putPayment(_a) {
        return __awaiter(this, arguments, void 0, function* ({ methodId, amount }) {
            const data = yield this.callApiV2({
                method: 'PUT',
                route: '/payment/charge',
                data: {
                    payment_method_id: methodId,
                    amount,
                },
            });
            return data;
        });
    }
    getSubscriptionPreview(billingPlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'POST',
                route: '/payment/subscription-setup',
                data: {
                    billingPlanId: billingPlanId,
                },
            });
            return data;
        });
    }
    createNewSubscription(methodId, billingPlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            methodId;
            const data = yield this.callApiV2({
                method: 'PUT',
                route: '/payment/subscription-confirm',
                data: {
                    methodId,
                    billingPlanId,
                },
            });
            return data;
        });
    }
    resumeSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'POST',
                route: '/payment/subscriptions/resume',
            });
        });
    }
    pauseSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'DELETE',
                route: '/payment/subscriptions/pause',
            });
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/transactions/balance',
            });
            return data;
        });
    }
    getTransactionsList(_a, filter_1) {
        return __awaiter(this, arguments, void 0, function* ({ limit, offset }, filter) {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/transactions',
                params: Object.assign({ skip: offset, limit }, filter),
            });
            return data;
        });
    }
    pollTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/transactions/poll',
                params,
            });
            return data;
        });
    }
    reactivateAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.callApiV2({
                method: 'POST',
                route: '/customers/inactive/resume',
            });
        });
    }
    getCustomerBillingInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/billing-info',
            });
            return data;
        });
    }
    setCustomerBillingInfo(billingInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'POST',
                route: '/payment/billing-info',
                data: Object.assign({}, billingInfo),
            });
            return data;
        });
    }
    getPaymentPlans() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/subscriptions',
            });
            return data;
        });
    }
    getSubscriptionData() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/subscriptions/status',
            });
            return data;
        });
    }
    getResourcesCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/transactions/usage-categories',
            });
            return data;
        });
    }
    getResourcesData(filterObj) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/transactions/usage',
                params: {
                    from: (_a = filterObj.date) === null || _a === void 0 ? void 0 : _a.dateFrom,
                    to: (_b = filterObj.date) === null || _b === void 0 ? void 0 : _b.dateTo,
                    categories: filterObj.category,
                },
            });
            return data;
        });
    }
    getPayableStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/customers/billable',
            });
            return data;
        });
    }
    getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/settings',
            });
            return data;
        });
    }
    getSettingsObj() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/settings',
            });
            return data.reduce((acc, curr) => {
                acc[curr.key] = curr.value;
                return acc;
            }, {});
        });
    }
    getSettingByKey(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'GET',
                route: `/settings/${key}`,
            });
            return data;
        });
    }
    createSetting(settingParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'POST',
                route: '/settings',
                data: Object.assign({}, settingParams),
            });
            return data;
        });
    }
    updateSetting(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'PUT',
                route: `/settings/${key}`,
                data: {
                    value,
                },
            });
            return data;
        });
    }
    setupAccount(email, customerType) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'POST',
                route: '/customers/setup-account',
                data: {
                    email,
                    customerType,
                },
            });
            return data;
        });
    }
    connectAccount(accountId, email, customerType) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                method: 'POST',
                route: '/customers/connect-account',
                data: {
                    email,
                    accountId,
                    customerType,
                },
            });
            return data;
        });
    }
    getOnboardingPaymentSetupSecret(_a, demo_1) {
        return __awaiter(this, arguments, void 0, function* ({ email, accountId, customerType }, demo) {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/initial-payment',
                params: Object.assign(Object.assign(Object.assign({ email }, (accountId && { accountId })), (demo && { demo })), (customerType && { customerType })),
            });
            return data;
        });
    }
    getOnboardingSubscriptionSecret(_a, demo_1) {
        return __awaiter(this, arguments, void 0, function* ({ email, accountId, customerType }, demo) {
            const data = yield this.callApiV2({
                method: 'GET',
                route: '/payment/initial-subscription',
                params: Object.assign(Object.assign(Object.assign({ email }, (accountId && { accountId })), (demo && { demo })), (customerType && { customerType })),
            });
            return data;
        });
    }
}
//# sourceMappingURL=Payments.js.map